export const getNumberOfImpostors = (totalPlayers) => {
    if (totalPlayers <= 4)
        return 1;

    if (totalPlayers <= 7)
        return 2;

    if (totalPlayers <= 10)
        return 3;

    if (totalPlayers <= 14)
        return 4;

    if (totalPlayers <= 18)
        return 5;

    return totalPlayers/4;
}

export const movieTitlesForImpostorWordGame = [
    { team: "A", movie: "Drishyam" },
    { team: "B", movie: "Aitraaz" },
    { team: "C", movie: "36 China Town" },
    { team: "D", movie: "Welcome" },
    { team: "E", movie: "Wake Up Sid" },
    { team: "F", movie: "De Dana Dan" },
    { team: "G", movie: "Singham" },
    { team: "H", movie: "Om Shaanti Om" },
    { team: "I", movie: "Taare Zameen Par" },
    { team: "J", movie: "Ek Tha Tiger" }
]